import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'react-bootstrap';
import { oneKlicks } from '../../../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../../../SDK/OneKlicksFileSDK';
import ImageShow from '../../../../Uitiles/ImageShow';
import { getuserdata } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { debugLog } from '../../../../utils/debug';

const AddAiService = ({ showAdd, setShowAdd, getAiServices, oldData }) => {
    console.log("oldData", oldData);
    const [file, setFile] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        pageLink: '',
        image: null,
        imagePreview: null
    });
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("file", file);
        setFile(file);
        if (file) {
            setFormData(prev => ({
                ...prev,
                image: file,
                imagePreview: URL.createObjectURL(file)
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let imageUrl = '';

            const uploadResponse = await OneKlicksFileSDK.uploadFile('ai_services', 'public', file);
            imageUrl = uploadResponse.file.root + '/' + uploadResponse.file.fileName;
            console.log("imageUrl", imageUrl);
            

            // Prepare service data
            const serviceData = {
                id: Date.now(),
                name: formData.name,
                description: formData.description,
                pageLink: formData.pageLink,
                image: imageUrl,
                status: 'active'
            };
            // old data and new data both are in data
            //  {id: 1759835207588, name: 'sdfdsferter', description: 'sdjfjdsfgsdfh', pageLink: 'sddsfdsfdf', image: '/uploads/3/ai_services/1759835207685_WhatsApp Image 2025-09-16 at 1.12.03 PM.jpeg', …}
            const newData = serviceData;
            
            // Handle both array and object cases for oldData
            let mergedData;
            if (Array.isArray(oldData)) {
                mergedData = [...oldData, newData];
            } else if (oldData && typeof oldData === 'object') {
                // If oldData is a single object, convert it to array
                mergedData = [oldData, newData];
            } else {
                // If oldData is null/undefined, start with new data
                mergedData = [newData];
            }
            const data = {
                kaey : "ai_services",
                status: 'active',
                data: JSON.stringify(mergedData)
            };
            const tableSchema = '';
            const tableName = 'front_end_sessions';
            const conditions = {
                kaey: 'ai_services'
            };
            const result = await oneKlicks.update(tableSchema, tableName, data, conditions);
            if (result.success) {
                toast.success('AI Service added successfully');
                setFormData({
                    name: '',
                    description: '',
                    pageLink: '',
                    image: null,
                    imagePreview: null
                });
                setShowAdd(false);
                getAiServices(); // Refresh the list
            } else {
                toast.error(result.message || 'Failed to add AI Service');
            }
            console.log("result", result);
        } catch (error) {
            debugLog('Error adding AI service:', error);
            toast.error('An error occurred while adding the AI service');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({
            name: '',
            description: '',
            pageLink: '',
            image: null,
            imagePreview: null
        });
        setShowAdd(false);
    };

    return (
        <Modal show={showAdd} onHide={handleClose} >
            <Modal.Header closeButton>
                <Modal.Title>Add AI Service</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Service Name *</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Enter service name"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="Enter service description"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Page Link *</Form.Label>
                        <Form.Control
                            type="text"
                            name="pageLink"
                            value={formData.pageLink}
                            onChange={handleInputChange}
                            placeholder="Enter page URL"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Service Image</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                        {formData.imagePreview && (
                            <div className="mt-2">
                                <img 
                                    src={formData.imagePreview} 
                                    alt="Preview" 
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                                />
                            </div>
                        )}
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2" style={{ gap: 10 }}>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? 'Adding...' : 'Add Service'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddAiService;
